export class User {
    constructor(
        public host: string,
        public port: number,
        public protocol: string,
        public id: number,
        public name: string,
        public token: string,
        public dashboardDate: Date
    ) {}

    dateStr(): string {
        let d: number;
        let m: number;
        let y: number;
        if (this.dashboardDate) {
            d = this.dashboardDate.getDate();
            m = this.dashboardDate.getMonth() + 1; // Month from 0 to 11
            y = this.dashboardDate.getFullYear();
        } else {
            const newDate = new Date();
            d = newDate.getDate();
            m = newDate.getMonth() + 1; // Month from 0 to 11
            y = newDate.getFullYear();
        }
        return '' + y + (m <= 9 ? '0' + m : m) + (d <= 9 ? '0' + d : d);
    }

    // dateText(): string {
    //     const dayNames = [
    //         'Zondag',
    //         'Maandag',
    //         'Dinsdag',
    //         'Woendag',
    //         'Donderdag',
    //         'Vrijdag',
    //         'Zaterdag'
    //     ];
    //     const monthNames = [
    //         'januari',
    //         'februari',
    //         'maart',
    //         'april',
    //         'mei',
    //         'juni',
    //         'juli',
    //         'augustus',
    //         'september',
    //         'oktober',
    //         'november',
    //         'december'
    //     ];
    //     let w: number;
    //     let d: number;
    //     let m: number;
    //     let y: number;
    //     if (this.dashboardDate) {
    //         w = this.dashboardDate.getDay();
    //         d = this.dashboardDate.getDate();
    //         m = this.dashboardDate.getMonth(); // Month from 0 to 11
    //         y = this.dashboardDate.getFullYear();
    //     } else {
    //         const newDate = new Date();
    //         w = newDate.getDay();
    //         d = newDate.getDate();
    //         m = newDate.getMonth(); // Month from 0 to 11
    //         y = newDate.getFullYear();
    //     }
    //     if (y === new Date().getFullYear() && m === new Date().getMonth() && d === new Date().getDate()) {
    //         return 'Vandaag';
    //     } else {
    //         return dayNames[w] + ' ' + d + ' ' + monthNames[m] + ' ' + y;
    //     }
    // }

    public url(methodName: string, params: string[], queryParams: string[]): string {

        // base URL:
        let result = `${this.protocol}://${this.host}:${this.port}/odapi/rest/TMethods/${methodName}/${this.token}`;

        // parameters ?
        for (const param of params) {
            if (param === 'id') {
                result = `${result}/${this.id}`;
            } else if (param === 'date') {
                result = `${result}/${this.dateStr()}`;
            } else {
                result = `${result}/${param}`;
            }
        }

        // query parameters ?
        if (queryParams.length > 0) {
            for (let i = 0; i < queryParams.length; i++) {
                    result = `${result}${i === 0 ? '?' : '&'}${queryParams[i]}`;
                }
            }
        return result;
    }

    public dateString(d : Date): string {
        return d.getFullYear().toString() + 
               (d.getMonth() < 9 ? '0' : '') + (d.getMonth() + 1).toString() +
               (d.getDate() < 10 ? '0': '') + d.getDate().toString();
    }

    public dateTimeString(d : Date): string {
        return d.getFullYear().toString() + 
               (d.getMonth() < 9 ? '0' : '') + (d.getMonth() + 1).toString() +
               (d.getDate() < 10 ? '0': '') + d.getDate().toString() +
               (d.getHours() < 10 ? '0': '') + d.getHours().toString() +
               (d.getMinutes() < 10 ? '0': '') + d.getMinutes().toString() +
               (d.getSeconds() < 10 ? '0': '') + d.getSeconds().toString();
    }

}
